import { Injectable } from '@angular/core';
import { CustomiserApiService } from './customiser-api.service';
import { statusResponseModel } from '@models/api-models/response-models/statusResponseModel';
import { UserService } from '@services/user.service';
import { OrderOnBehalfService } from '@services/order-on-behalf.service';

@Injectable({
    providedIn: 'root',
})
export class StatusService {
    private lastApiVersion: string;

    constructor(
        private customiserApi: CustomiserApiService,
        private userService: UserService
    ) { }
    

    setApiVersion(version: string): void {
        this.lastApiVersion = !version ? '' : version;
    }

    getApiVersion(): string {
        return this.lastApiVersion ?? '';
    }

    private validateAndParseVersion(version: string): number[] {
        const parts = version.split('.');

        // Ensure there are exactly 3 parts and all parts are valid numbers
        if (parts.length !== 3 || parts.some(part => part.trim() === '' || isNaN(parseInt(part, 10)))) {
            return [];
        }

        return parts.map(part => parseInt(part, 10));
    }


    isVersionMismatch(apiVersion: string): boolean {
        if (!apiVersion || apiVersion === null || apiVersion === null) {
            //unable to determine api version number. Return false!
            return false;
        }

        const parsed = this.validateAndParseVersion(apiVersion);
        if (parsed.length !== 3) {
            //incorrect api version number syntax. Return false!
            return false;
        }

        if (!this.lastApiVersion) {
            return false;
        }

        const currentParts = this.validateAndParseVersion(apiVersion);
        const apiParts = this.validateAndParseVersion(this.lastApiVersion);

        for (let i = 0; i < Math.max(currentParts.length, apiParts.length); i++) {
            const current = currentParts[i] || 0;
            const api = apiParts[i] || 0;
            if (current !== api) {
                return true;
            }
        }

        return false;
    }

    public scheduleStatusCheck() {
        this.statusCheck();

        setInterval(() => {
            this.statusCheck();
        }, 300000); // every 5 minute
    }

    private async statusCheck() {
        try {
            let status = await this.customiserApi.get<statusResponseModel>(`status`);

            // if (status?.UserModel) {
			// 	status.UserModel.OrderIds = status.CustomerOrderRelevantModel.OrderIds;
            //     this.userService.setUser(status?.UserModel);
            // }

            if (status?.Version) {
                let isFirstFetch = !this.getApiVersion();
                if (isFirstFetch) {
                    this.setApiVersion(status.Version);
                    isFirstFetch = false;
                } else if (this.isVersionMismatch(status.Version)) {
                    console.warn('Version mismatch detected! Reloading...');

                    //Other frontend refresh related tasks can be performed here. Eg. session or other storage cleanup
                    this.userService.removeAdminModeEnabledEntry();

                    setTimeout(() => window.location.reload(), 500);
                }
            }
        }
        catch (error) {
            console.error('Error performing version check', error);
        }
    }
}
